export default {"src":"/_next/static/media/personal-relations.611ae761.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};